import classNames from "classnames";
import { ReactNode } from "react";

type CirclePercentageProps = {
  borderSize?: number;
  scale: number;
  /** Background colour classes for the track and its filled part, e.g. `bg-usage-track`. */
  trackClassName: string;
  fillClassName: string;
  children?: ReactNode;
};

const CirclePercentage: React.FunctionComponent<CirclePercentageProps> = ({
  borderSize = 8,
  scale,
  trackClassName,
  fillClassName,
  children,
}) => {
  return (
    <div
      className={classNames(
        "relative text-center rounded-full w-full",
        trackClassName
      )}
      style={{
        height: `${borderSize}px`,
      }}
    >
      <div
        className={classNames(
          "rounded-full text-center relative flex justify-center items-center",
          fillClassName
        )}
        style={{
          top: 0,
          left: 0,
          width: `${scale * 100}%`,
          height: `${borderSize}px`,
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default CirclePercentage;
